module.exports = __webpack_public_path__ + "static/ig-banner-horizonal-large-020a9fa21dc33751b0c7d3a14305ea73.jpg";